<div  mat-dialog-title>{{header}}
  <div class="dialog-close-button">
      <a (click)="onClose()" id="close">
          <img src="/assets/images/close-popup.png">
      </a>
  </div>
</div>
<div mat-dialog-content cdkFocusInitial>
  <span *ngIf="data.productDescription">
    Are you sure you want to remove {{data.itemCIN}} - {{data.productDescription}} from your {{data.selectedFavList.name.replace(' ', '&nbsp;')}} list?
  </span>
  <span *ngIf="!data.productDescription">
    Are you sure you want to delete your {{data.selectedFavList.name.replace(' ', '&nbsp;')}} list?
  </span>
</div>
<div mat-dialog-actions>
  <button mat-raised-button id="btn-confirm" [mat-dialog-close]="true">{{confirmBtn}}</button>
  <button mat-raised-button [mat-dialog-close]="false" id="btn-cancel">{{cancelBtn}}</button>
</div>